import { Component, inject, input } from '@angular/core';
import {
  injectDatePickerState,
  NgpDatePickerCell,
  NgpDatePickerCellRender,
  NgpDatePickerDateButton,
} from 'ng-primitives/date-picker';
import { DatePickerVariant } from '../date-picker.component';
import { DatePickerUtilsService } from '../services/date-picker-utils.service';
import { DayComponent } from './day.component';

@Component({
  selector: 'joii-date-picker-days',
  imports: [NgpDatePickerCellRender, NgpDatePickerCell, DayComponent, NgpDatePickerDateButton],
  template: `
    <div *ngpDatePickerCellRender="let date" ngpDatePickerCell>
      <!--
        ngpDatePickerDateButton only sets the roving tabindex in an after-render effect, which runs after
        it tries to focus a day keyboard navigation has just rendered (e.g. PageUp to a new month). The
        static -1 makes new days focusable straight away; the directive then takes over.
      -->
      <joii-day
        ngpDatePickerDateButton
        tabindex="-1"
        [label]="date.getDate()"
        [selected]="dateUtils.isSelected(date, state())"
        [today]="dateUtils.isToday(date)"
        [disabled]="date.disabled || isDisabled(date)"
        [hasEvent]="hasEvent(date)"
      />
    </div>
  `,
  styles: `
    :host {
      display: grid;
      width: 100%;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      gap: 8px;
      margin-top: 4px;
    }
  `,
})
export class DayRowsComponent {
  state = injectDatePickerState<Date>();
  dateUtils = inject(DatePickerUtilsService);
  days = input<number[]>([]);
  events = input<Date[]>([]);
  variant = input<DatePickerVariant>('showEvents');
  isDisabled(date: Date): boolean {
    return this.variant() === 'enableEvents' && !this.hasEvent(date);
  }
  hasEvent(date: Date): boolean {
    return this.events().some(
      (event) =>
        date.getDate() === event.getDate() &&
        date.getMonth() === event.getMonth() &&
        date.getFullYear() === event.getFullYear()
    );
  }
}
